module.exports = (state) => {
  state.notificationData = {}
  state.isShown = false
}
